import React from 'react'
import PropTypes from 'prop-types'
import { ipxUrl } from '@/utils/ipix'

/**
 * ImgWithFallback
 * 
 * Menyediakan:
 * - Manual srcSet via `srcSet`
 * - Manual WebP srcSet via `srcSetWebp`
 * - Legacy dua URL via `srcAvif`/`srcWebp`
 * - Dynamic IPX mode via `src`, `width`, `height`, `quality`, `ipxBase`
 * - Fallback original via `fallbackSrc`
 * - Responsive sizes via `sizes`
 */
const ImgWithFallback = ({
  srcAvif,
  srcWebp,
  src,
  width,
  height,
  quality = 90,
  ipxBase,
  srcSet,
  srcSetWebp,
  fallbackSrc,
  sizes,
  alt,
  className = '',
  ...delegated
}) => {
  let ipxAvif = null;
  let ipxWebp = null;

  if (src && width && height) {
    const ipxOpts = { width, height, quality };
    ipxAvif = ipxUrl(src, { ...ipxOpts, format: 'avif' }, ipxBase);
    ipxWebp = ipxUrl(src, { ...ipxOpts, format: 'webp' }, ipxBase);
  }
  const avifSourceForTag = srcAvif || ipxAvif;
  const webpBaseUrl = srcWebp || ipxWebp;
  const webpSourceForTag = srcSetWebp || webpBaseUrl;
  const imgSrcToUse = fallbackSrc || srcWebp || ipxWebp || src || '';

  return (
    <picture className={className} {...delegated}>
      {/* AVIF source */}
      {avifSourceForTag && <source type="image/avif" srcSet={avifSourceForTag} sizes={sizes} />}
      {/* WebP source */}
      {webpSourceForTag && <source type="image/webp" srcSet={webpSourceForTag} sizes={sizes} />}
      {/* Fallback <img> */}
      <img
        src={imgSrcToUse}
        {...(srcSet ? { srcSet } : {})}
        sizes={sizes}
        alt={alt}
        className={className}
      />
    </picture>
  )
}

ImgWithFallback.propTypes = {
  // Legacy
  srcAvif: PropTypes.string,
  srcWebp: PropTypes.string,
  // IPX mode
  src: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  quality: PropTypes.number,
  ipxBase: PropTypes.string,
  // Manual overrides
  srcSet: PropTypes.string,
  srcSetWebp: PropTypes.string,
  fallbackSrc: PropTypes.string,
  sizes: PropTypes.string,
  // Common
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default ImgWithFallback
